import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { requestReports } from "actions";

import { getLivestockSaleId, getSaleyardName } from "lib/navigation";

import { getIsOnline } from "selectors";

import WaitForSync from "components/LoadingSpinner/WaitForSync";
import { ApiModel } from "constants/loading";

import BusinessUserSaleLotsView from "./BusinessUserSaleLotsView";

const BusinessUserSaleLots = (): React.JSX.Element => {
  const dispatch = useDispatch();

  const isOnline = useSelector(getIsOnline);
  const saleyardName = getSaleyardName();
  const livestockSaleId = getLivestockSaleId();

  useEffect(() => {
    dispatch(requestReports(saleyardName, livestockSaleId));
  }, [dispatch, saleyardName, livestockSaleId, isOnline]);

  return (
    <WaitForSync
      requiredData={[
        ApiModel.BUSINESSES,
        ApiModel.CONSIGNMENTS,
        ApiModel.REPORTS,
        ApiModel.SALE_LOTS,
      ]}
    >
      <BusinessUserSaleLotsView />
    </WaitForSync>
  );
};

export default BusinessUserSaleLots;
